/**
 * Terms Acceptance Modal - JavaScript
 *
 * Interceptiert Bid-Buttons und zeigt zweistufiges Popup fuer
 * AGBs und Auktionsinformationen vor dem ersten Gebot.
 * PDFs werden mit pdf.js gerendert, Button wird nach Scroll-to-Bottom freigeschaltet.
 *
 * @package Brandner_Custom
 * @since 1.2.0
 */

(function($) {
    'use strict';

    // Konfiguration aus PHP
    var config = window.brandnerTerms || {};

    // Status
    var isModalOpen = false;
    var currentStep = 1;
    var totalSteps = 0;
    var termsData = null;
    var pendingBidButton = null;
    var acceptEnabled = false;

    // pdf.js — lokal ausgeliefert, siehe assets/vendor/pdfjs/
    // Wird bewusst NICHT vom CDN geladen: die Auktionsinformationen-PDFs bringen
    // keine eigenen Schriften mit (Standard-14 "Helvetica"), pdf.js muss die
    // Ersatzschrift also selbst stellen. Faellt die aus, rendert pdf.js
    // umkodierte Zeichencodes und der Kunde sieht Zeichensalat.
    var PDFJS_VERSION = '3.11.174';
    var PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VERSION;
    var PDFJS_BASE = (config.pdfjsUrl || '').replace(/\/$/, '') || PDFJS_CDN;
    var PDFJS_CMAP_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@' + PDFJS_VERSION + '/cmaps/';
    var PDFJS_FONT_URL = config.pdfjsUrl
        ? config.pdfjsUrl.replace(/\/$/, '') + '/standard_fonts/'
        : 'https://cdn.jsdelivr.net/npm/pdfjs-dist@' + PDFJS_VERSION + '/standard_fonts/';
    var pdfjsLoaded = false;
    var fontDataOk = null;

    /**
     * Prueft einmalig, ob die Glyphen-Daten erreichbar sind.
     *
     * disableFontFace zeichnet Glyphen aus den Standard-Schriftdaten. Fehlen die,
     * rendert die Seite voellig ohne Text — der Kunde saehe ein leeres Dokument
     * mit Akzeptieren-Button. In dem Fall lieber zurueck auf die Browser-
     * Schriftmaschinerie: schlechter als der Idealfall, aber lesbar.
     */
    function checkFontData() {
        if (fontDataOk !== null) {
            return Promise.resolve(fontDataOk);
        }
        if (!window.fetch) {
            fontDataOk = false;
            return Promise.resolve(false);
        }
        return fetch(PDFJS_FONT_URL + 'LiberationSans-Regular.ttf', { method: 'HEAD' })
            .then(function(r) { fontDataOk = !!r.ok; return fontDataOk; })
            .catch(function() { fontDataOk = false; return false; });
    }

    // Selektoren fuer Bid-Buttons
    var bidButtonSelectors = [
        '#placebidbutton',           // Max Bid Button
        '#placebidbutton_direct',    // Direct Bid Button
        '.place-bid-button',         // Alternative Klasse
        'button[name="uwa-place-bid"]', // Form Submit
        '.bid-submit-btn',           // Card-View Button
        '.sticky-bar-bid',           // Mobile Sticky-Leiste Losseite (oeffnet das Gebots-Sheet)
        '#single-bid-submit'         // "Gebot abgeben" im Gebots-Sheet der Losseite
    ].join(', ');

    /**
     * pdf.js dynamisch vom CDN laden
     */
    function loadPdfJs() {
        return new Promise(function(resolve, reject) {
            if (pdfjsLoaded && window.pdfjsLib) {
                resolve();
                return;
            }
            var script = document.createElement('script');
            script.src = PDFJS_BASE + '/pdf.min.js';
            script.onload = function() {
                if (window.pdfjsLib) {
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + '/pdf.worker.min.js';
                    pdfjsLoaded = true;
                    resolve();
                } else {
                    reject(new Error('pdfjsLib not available after script load'));
                }
            };
            script.onerror = function() {
                reject(new Error('Failed to load pdf.js from CDN'));
            };
            document.head.appendChild(script);
        });
    }

    /**
     * Modal HTML erstellen und einfuegen
     */
    function createModal() {
        if ($('#brandner-terms-modal').length) return;

        var html = `
            <div class="brandner-terms-overlay" id="brandner-terms-modal">
                <div class="brandner-terms-modal">
                    <div class="brandner-terms-header">
                        <div class="brandner-terms-header-left">
                            <span class="brandner-terms-step" id="terms-step-indicator"></span>
                            <h3 class="brandner-terms-title" id="terms-title"></h3>
                        </div>
                        <button type="button" class="brandner-terms-close" id="terms-close-btn" aria-label="Schliessen">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <div class="brandner-terms-body loading" id="terms-body">
                        <div id="terms-pdf-container" class="terms-pdf-scroll-container"></div>
                    </div>
                    <div class="brandner-terms-scroll-hint" id="terms-scroll-hint">
                        <span>${config.i18n?.scrollHint || 'Bitte scrollen Sie zum Ende'}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </div>
                    <div class="brandner-terms-footer">
                        <div class="brandner-terms-footer-hint" id="terms-footer-hint">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                            </svg>
                            <span>Bitte lesen Sie das Dokument aufmerksam durch</span>
                        </div>
                        <button type="button" class="brandner-terms-accept" id="terms-accept-btn" disabled>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            <span id="terms-accept-text">${config.i18n?.acceptBtn || 'Gelesen und akzeptieren'}</span>
                        </button>
                    </div>
                </div>
            </div>
        `;

        $('body').append(html);
        bindModalEvents();
    }

    /**
     * Modal Events binden
     */
    function bindModalEvents() {
        // Close Button
        $('#terms-close-btn').on('click', closeModal);

        // Overlay Click schliesst Modal
        $('#brandner-terms-modal').on('click', function(e) {
            if ($(e.target).is('#brandner-terms-modal')) {
                closeModal();
            }
        });

        // ESC Taste
        $(document).on('keydown.termsModal', function(e) {
            if (e.key === 'Escape' && isModalOpen) {
                closeModal();
            }
        });

        // Accept Button
        $('#terms-accept-btn').on('click', function() {
            if (!acceptEnabled) {
                // Scroll-Hint zeigen
                showScrollHint();
                // Footer-Hint Text aendern um klar zu machen was fehlt
                $('#terms-footer-hint span').text('Bitte scrollen Sie bis zum Ende des Dokuments');
                // Shake-Animation auf Footer-Hint
                $('#terms-footer-hint').addClass('shake');
                setTimeout(function() {
                    $('#terms-footer-hint').removeClass('shake');
                }, 600);
                return;
            }
            handleAccept();
        });
    }

    /**
     * Modal oeffnen
     */
    function openModal() {
        createModal();
        isModalOpen = true;
        $('body').addClass('brandner-terms-modal-open');
        $('#brandner-terms-modal').addClass('active');

        // Ersten Schritt anzeigen
        showStep(1);
    }

    /**
     * Modal schliessen
     */
    function closeModal() {
        isModalOpen = false;
        $('body').removeClass('brandner-terms-modal-open');
        $('#brandner-terms-modal').removeClass('active');

        // Scroll-Listener aufraeumen
        $('#terms-pdf-container').off('scroll.terms');

        // Reset (aber termsDataByProduct und termsStatusByProduct behalten fuer naechsten Klick)
        pendingBidButton = null;
        currentStep = 1;
        acceptEnabled = false;
        // termsData und totalSteps NICHT zuruecksetzen - werden fuer naechsten Klick gebraucht
    }

    /**
     * Schritt anzeigen
     */
    function showStep(step) {
        currentStep = step;
        acceptEnabled = false;
        $('#terms-accept-btn').prop('disabled', true);
        $('#terms-body').addClass('loading');
        $('#terms-scroll-hint').removeClass('visible');

        var stepText = '';
        var title = '';
        var pdfUrl = '';

        if (step === 1) {
            if (termsData.has_project_terms) {
                // Auktionsinformationen zuerst anzeigen
                stepText = totalSteps > 1 ? (config.i18n?.step1of2 || 'Schritt 1 von 2') : '';
                title = config.i18n?.projectTitle || 'Auktions-Informationen';
                pdfUrl = termsData.project_terms_url;
            } else if (termsData.has_agb) {
                // Nur AGBs vorhanden
                stepText = '';
                title = config.i18n?.agbTitle || 'Allgemeine Auktionsbedingungen';
                pdfUrl = termsData.agb_url;
            }
        } else if (step === 2) {
            // AGBs als zweiter Schritt
            stepText = config.i18n?.step2of2 || 'Schritt 2 von 2';
            title = config.i18n?.agbTitle || 'Allgemeine Auktionsbedingungen';
            pdfUrl = termsData.agb_url;
        }

        // UI aktualisieren
        $('#terms-step-indicator').text(stepText).toggle(!!stepText);
        $('#terms-title').text(title);

        // Button-Text: immer "Akzeptieren"
        $('#terms-accept-text').text(config.i18n?.acceptBtn || 'Akzeptieren');

        // PDF mit pdf.js rendern
        if (pdfUrl) {
            renderPdf(pdfUrl, document.getElementById('terms-pdf-container'));
        }
    }

    /**
     * PDF mit pdf.js in scrollbaren Container rendern
     */
    function renderPdf(url, container) {
        container.innerHTML = '';
        container.scrollTop = 0;
        acceptEnabled = false;
        $('#terms-accept-btn').prop('disabled', true);
        $('#terms-body').addClass('loading');
        $('#terms-scroll-hint').removeClass('visible');
        // Scroll-Listener vom vorherigen PDF entfernen
        $(container).off('scroll.terms');

        loadPdfJs().then(checkFontData).then(function(glyphenVerfuegbar) {
            return window.pdfjsLib.getDocument({
                url: url,
                cMapUrl: PDFJS_CMAP_URL,
                cMapPacked: true,
                standardFontDataUrl: PDFJS_FONT_URL,
                // Glyphen direkt als Vektorpfade auf das Canvas zeichnen, statt
                // pdf.js eigene Schriften per @font-face im Browser registrieren
                // zu lassen. Diese generierten Schriften (g_d0_sf*) tragen eine
                // umkodierte Zeichentabelle; greifen sie beim Kunden nicht
                // (Font-Policy, Sicherheitssoftware, defekter Font-Cache),
                // zeichnet der Browser die Ersatzschrift mit den umkodierten
                // Codes -> unlesbarer Zeichensalat. Ohne @font-face kann das
                // nicht passieren.
                // Nur aktivieren, wenn die Glyphen-Daten wirklich erreichbar sind —
                // sonst rendert die Seite ganz ohne Text (siehe checkFontData).
                disableFontFace: glyphenVerfuegbar
            }).promise;
        }).then(function(pdf) {
            var renderChain = Promise.resolve();
            for (var i = 1; i <= pdf.numPages; i++) {
                (function(pageNum) {
                    renderChain = renderChain.then(function() {
                        return pdf.getPage(pageNum);
                    }).then(function(page) {
                        // Scale berechnen: Canvas-Breite = Container-Breite
                        var containerWidth = container.clientWidth - 16; // 8px margin each side
                        var viewport = page.getViewport({ scale: 1 });
                        var scale = containerWidth / viewport.width;
                        var dpr = window.devicePixelRatio || 1;
                        // CSS-Viewport fuer Style-Dimensionen, HiDPI-Viewport fuer Rendering
                        var cssViewport = page.getViewport({ scale: scale });
                        var renderViewport = page.getViewport({ scale: scale * dpr });

                        var canvas = document.createElement('canvas');
                        canvas.className = 'terms-pdf-page';
                        canvas.width = renderViewport.width;
                        canvas.height = renderViewport.height;
                        canvas.style.width = cssViewport.width + 'px';
                        canvas.style.height = cssViewport.height + 'px';
                        container.appendChild(canvas);

                        var ctx = canvas.getContext('2d');
                        // Weissen Hintergrund setzen (Canvas ist sonst transparent)
                        ctx.fillStyle = '#ffffff';
                        ctx.fillRect(0, 0, renderViewport.width, renderViewport.height);
                        return page.render({
                            canvasContext: ctx,
                            viewport: renderViewport,
                            background: 'rgba(255, 255, 255, 1)'
                        }).promise;
                    });
                })(i);
            }
            return renderChain;
        }).then(function() {
            $('#terms-body').removeClass('loading');
            initScrollDetection(container);
        }).catch(function(err) {
            console.error('[Brandner Terms] PDF render error:', err);
            $('#terms-body').removeClass('loading');
            // Fallback: Button nach Fehler freischalten damit User nicht blockiert wird
            enableAcceptButton();
        });
    }

    /**
     * Scroll-Detection initialisieren
     */
    function initScrollDetection(container) {
        var el = container;

        // Pruefen ob Inhalt ueberhaupt scrollbar ist
        if (el.scrollHeight <= el.clientHeight + 5) {
            // Inhalt passt komplett rein - sofort aktivieren
            enableAcceptButton();
            return;
        }

        // Scroll-Hint anzeigen
        showScrollHint();

        // Scroll-Event: Button aktivieren wenn Bottom erreicht
        $(container).off('scroll.terms').on('scroll.terms', function() {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
                enableAcceptButton();
                $('#terms-scroll-hint').removeClass('visible');
                $(container).off('scroll.terms');
            }
        });
    }

    /**
     * Accept-Button aktivieren
     */
    function enableAcceptButton() {
        acceptEnabled = true;
        $('#terms-accept-btn').prop('disabled', false);
        $('#terms-scroll-hint').removeClass('visible');
    }

    /**
     * Scroll-Hint anzeigen
     */
    function showScrollHint() {
        $('#terms-scroll-hint').addClass('visible');
    }

    /**
     * Accept-Klick verarbeiten
     */
    function handleAccept() {
        var isLastStep = (currentStep === totalSteps);

        if (!isLastStep) {
            // Naechster Schritt
            showStep(currentStep + 1);
            return;
        }

        // Letzter Schritt - Akzeptanz an Server senden
        $('#terms-accept-btn').prop('disabled', true).find('span').text(config.i18n?.loading || 'Wird gespeichert...');

        $.ajax({
            url: config.ajaxUrl,
            type: 'POST',
            data: {
                action: 'brandner_accept_terms',
                nonce: config.nonce,
                project_id: termsData.project_id
            },
            success: function(response) {
                if (response.success) {
                    // Terms wurden akzeptiert - Per-Product Status aktualisieren
                    if (currentProductId) {
                        termsStatusByProduct[currentProductId] = false;
                    }
                    // Ausloeser VOR closeModal() sichern — closeModal() setzt pendingBidButton auf null
                    var btnToResume = pendingBidButton;
                    closeModal();
                    if (typeof window.showBidToast === 'function') {
                        window.showBidToast('Bedingungen akzeptiert', 'success');
                    }
                    // Original Bid-Button erneut triggern (Bestaetigungsansicht/Sheet/Popup folgt)
                    if (btnToResume) {
                        triggerOriginalBid(btnToResume);
                    }
                } else {
                    alert(response.data?.message || 'Fehler beim Speichern');
                    $('#terms-accept-btn').prop('disabled', false).find('span').text(config.i18n?.acceptBtn || 'Gelesen und akzeptieren');
                }
            },
            error: function() {
                alert('Netzwerkfehler. Bitte versuchen Sie es erneut.');
                $('#terms-accept-btn').prop('disabled', false).find('span').text(config.i18n?.acceptBtn || 'Gelesen und akzeptieren');
            }
        });
    }

    /**
     * Original Bid-Button erneut triggern
     */
    function triggerOriginalBid(button) {
        // Kurze Verzoegerung damit Modal vollstaendig geschlossen ist
        setTimeout(function() {
            // Flag setzen damit unser Interceptor nicht erneut greift
            $(button).data('terms-accepted', true);

            // Neuen Click-Event erstellen und dispatchen
            // Das loest alle anderen Event-Listener aus (z.B. Bestatigungsdialog)
            var clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            button.dispatchEvent(clickEvent);

        }, 150);
    }

    /**
     * Per-Product Terms-Tracking
     * Werte: undefined = nicht geprueft, true = terms noetig, false = bereits akzeptiert
     */
    var termsStatusByProduct = {};
    var termsDataByProduct = {};
    var currentProductId = null;

    /**
     * ProductId aus Button-Kontext ermitteln
     */
    function getProductIdFromButton(btn) {
        // Card-Ansicht: productId aus Card-Container
        var card = btn.closest('.brandner-auction-card-bid, [data-product-id]');
        if (card) {
            return card.getAttribute('data-product-id') || card.dataset.productId;
        }
        // Einzelprodukt: aus Config
        return config.productId || null;
    }

    /**
     * Pre-Check: Status vorab ermitteln (ohne Modal)
     * Wird nur auf Einzelproduktseiten ausgefuehrt (wo productId bekannt ist)
     */
    function preCheckTermsStatus() {
        if (!config.productId) return; // Kein Pre-Check auf Loop-Seiten

        var productId = config.productId;
        $.ajax({
            url: config.ajaxUrl,
            type: 'POST',
            data: {
                action: 'brandner_check_terms_status',
                nonce: config.nonce,
                product_id: productId
            },
            success: function(response) {
                if (response.success) {
                    if (response.data.terms_required) {
                        termsStatusByProduct[productId] = true;
                        termsDataByProduct[productId] = response.data;
                    } else {
                        termsStatusByProduct[productId] = false;
                    }
                }
            }
        });
    }

    /**
     * Bid-Button Click interceptieren
     * WICHTIG: Wird als capturing listener registriert um VOR anderen Handlern zu laufen
     */
    function interceptBidButton(e) {
        var btn = e.target.closest(bidButtonSelectors.split(', ').join(', '));
        if (!btn) return;

        // Nicht eingeloggt (config nicht gesetzt) -> durchlassen
        // Damit der normale Login-Flow (Porto Popup) greifen kann
        if (!config.ajaxUrl) return;

        var $btn = $(btn);

        // Wenn bereits akzeptiert (durch uns getriggert), durchlassen
        if ($btn.data('terms-accepted')) {
            $btn.removeData('terms-accepted');
            return; // Event normal durchlassen
        }

        // ProductId dynamisch ermitteln
        var productId = getProductIdFromButton(btn);
        if (!productId) return; // Keine productId gefunden, durchlassen

        var status = termsStatusByProduct[productId]; // undefined, true, oder false

        // Wenn Terms nicht noetig, durchlassen
        if (status === false) {
            return;
        }

        // Wenn noch nicht geprueft oder Terms noetig: blockieren
        if (status === undefined || status === true) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            pendingBidButton = btn;
            currentProductId = productId;

            if (status === true && termsDataByProduct[productId]) {
                // Bereits geprueft, direkt Modal oeffnen
                termsData = termsDataByProduct[productId];
                totalSteps = 0;
                if (termsData.has_agb) totalSteps++;
                if (termsData.has_project_terms) totalSteps++;
                openModal();
            } else {
                // Noch nicht geprueft, jetzt pruefen
                $.ajax({
                    url: config.ajaxUrl,
                    type: 'POST',
                    data: {
                        action: 'brandner_check_terms_status',
                        nonce: config.nonce,
                        product_id: productId
                    },
                    success: function(response) {
                        if (response.success) {
                            if (response.data.terms_required) {
                                termsStatusByProduct[productId] = true;
                                termsDataByProduct[productId] = response.data;
                                termsData = response.data;
                                totalSteps = 0;
                                if (termsData.has_agb) totalSteps++;
                                if (termsData.has_project_terms) totalSteps++;
                                openModal();
                            } else {
                                termsStatusByProduct[productId] = false;
                                triggerOriginalBid(pendingBidButton);
                            }
                        } else {
                            console.warn('[Brandner Terms] Check failed:', response.data);
                            triggerOriginalBid(pendingBidButton);
                        }
                    },
                    error: function() {
                        console.warn('[Brandner Terms] Network error');
                        triggerOriginalBid(pendingBidButton);
                    }
                });
            }

            return false;
        }
    }

    /**
     * Oeffentliche API fuer die Gebots-Handler (Sheet, Popup, Desktop):
     * Der Server hat ein Gebot mit terms_required abgelehnt (AGB-Status im
     * Browser veraltet). Status verwerfen und den Ausloeser erneut klicken —
     * der Interceptor prueft dann neu, zeigt das Modal und setzt nach dem
     * Akzeptieren den Ausloeser fort. Rueckgabe false = nicht moeglich,
     * Aufrufer zeigt dann die Server-Meldung.
     */
    window.BrandnerTerms = {
        require: function(productId, triggerButton) {
            if (!config.ajaxUrl || !productId) return false;
            delete termsStatusByProduct[productId];
            delete termsDataByProduct[productId];
            if (!triggerButton || !triggerButton.matches || !triggerButton.matches(bidButtonSelectors)) return false;
            $(triggerButton).removeData('terms-accepted');
            triggerButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            return true;
        }
    };

    /**
     * Initialisierung
     */
    function init() {
        // Pre-Check beim Laden
        preCheckTermsStatus();

        // Capturing Event Listener - laeuft VOR allen anderen Click-Handlern
        // Das ist wichtig weil das Brandner-Custom-Plugin auch Click-Handler hat
        document.addEventListener('click', interceptBidButton, true);

    }

    // DOM Ready
    $(document).ready(init);

})(jQuery);
